import t from 'tcomb';
import UUID from './UUID';
import Locale from './Locale';
import Sponsor from './Sponsor';
import Reducer from './Reducer';
import Adv_Box from './Adv_Box';
import Color from './Color';
import URL from './URL';
import Partners from './Partners';
import Widget from './Widget';

const Lattice = t.struct({
  id: UUID,
  locale: Locale,
  sponsor: Sponsor,
  reducers: t.list(Reducer),
  share_url: t.maybe(URL),
  share_caption: t.maybe(t.Str),
  theme_btn_color: t.maybe(Color),
  theme_bg_color: t.maybe(Color),
  has_third_parties_privacy: t.maybe(t.Bool),
  adv_boxes: t.maybe(t.list(Adv_Box)),
  partners: t.maybe(Partners),
  theme_btn_font_color: t.maybe(Color),
  theme_bg_font_color: t.maybe(Color),
  is_white_label: t.maybe(t.Bool),
  widget: t.maybe(Widget),
  is_hidden: t.maybe(t.Bool)
}, 'Lattice');

Lattice.of = (lattice) => {
  lattice.locale = Locale.of(lattice.locale);
  return new Lattice(lattice);
};
module.exports = Lattice;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Lattice.js
 **/